// extracted by mini-css-extract-plugin
export default {"login__browser":"styles_login__browser__XH2zR","login__browserText":"styles_login__browserText__Cv6JN","login__browserLogo":"styles_login__browserLogo__zHmGk"};